// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__q4H0Z","topHeader":"style__topHeader__xNOTB","hideEditProfile":"style__hideEditProfile__WruPu","logo":"style__logo__PgcIE"};